import {Pressable, StyleSheet, Text, View} from "react-native-web";
// import { LinearGradient } from 'expo-linear-gradient';
import {vw} from "../../../../utils/tool/vw";
import {ReactComponent as Like} from "../../../../assets/icons/heart-outline.svg";
import {ReactComponent as ArrowBack} from "../../../../assets/icons/carret.left.svg";
import React, {FC, useState} from "react";
import {$semiTransparentWhite, $white} from "../../../constants/style";
import {InformationDies} from "../../../ui-kit/InformationDies";
import {DishType} from "../../../types/ResponseType";
import style from "./SingleDishVideo.module.scss";
import {useNavigate} from "react-router-dom";
import {Modal} from "../../../ui-kit/Modal/Modal";
import {useAppSelector} from "../../../../utils/hook/redux-hooks";
import {QuantityControl} from "../../../ui-kit/Cart/QuantityControl";
import {useOrderingEnabled} from "../../../../utils/hook/useOrderingEnabled";
import {Loader} from "../../../ui-kit/Loader/Loader";
import {formatPrice} from "../../../../utils/tool/format";
import { ExpandableText } from "src/common/ui-kit/ExpandableText";
import { RecommendedBadge } from "src/common/ui-kit/RecommendedBadge";
import { TopChoiceBadge } from "src/common/ui-kit/TopChoiceBadge";


type IProps = {
    selectedDish: DishType | null;
    /** Show top choice badge only when menu has top choice enabled. */
    showTopChoiceBadge?: boolean;
    /** Top choice badge URL from menu settings (custom icon). null = use default icon. */
    topChoiceBadgeUrl?: string | null;
    /** Show recommended badge only when menu has recommended enabled. */
    showRecommendedBadge?: boolean;
    /** Recommended badge URL from menu settings (custom icon). null = use default icon. */
    recommendedBadgeUrl?: string | null;
};
export const SingleDishVideo: FC<IProps> = ({
                                                selectedDish,
                                                showTopChoiceBadge,
                                                topChoiceBadgeUrl,
                                                showRecommendedBadge,
                                                recommendedBadgeUrl
                                            }) => {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const {loading} = useAppSelector(state => state.menu);
    const orderingEnabled = useOrderingEnabled();
    if (loading) return <View style={{
        width: "100%",
        height: vw(660),
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}><Loader/></View>

    return (
        <View style={styles.videoWrapper}>
            <video
                src={selectedDish?.video ? selectedDish.video.url : ""}
                autoPlay
                muted
                loop
                style={{width: "100%", position: "absolute"}}
                playsInline
            >
                Your browser does not support the video tag.
            </video>
            <Pressable
                onPress={() => navigate(-1)}
                style={{position: "absolute", top: vw(13), left: vw(13), padding: vw(10)}}
            >
                <ArrowBack width={vw(24)} height={vw(24)}/>
            </Pressable>
            <div className={style.container}>
                <div className={style.main}>
                    <div className={style.headline}>
                        <View style={styles.videoInfo}>
                            <View>
                                <Text style={styles.videoHeader}>{selectedDish?.name}</Text>
                                <ExpandableText
                                    text={selectedDish?.description}
                                    maxLength={110}
                                    style={styles.videoDescription}
                                />
                            </View>
                        </View>
                        {(showTopChoiceBadge || showRecommendedBadge) && (
                            <div className={style.badgesContainer}>
                                {showTopChoiceBadge && (
                                    <div className={style.topChoiceBadgeWrapper}>
                                        <TopChoiceBadge
                                            isTopChoice
                                            customBadgeUrl={topChoiceBadgeUrl ?? null}
                                        />
                                    </div>
                                )}
                                {showRecommendedBadge && (
                                    <div className={style.recommendedBadgeWrapper}>
                                        <RecommendedBadge
                                            isRecommended
                                            customBadgeUrl={recommendedBadgeUrl ?? null}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className={style.metaRow}>
                        <InformationDies
                            price={formatPrice(selectedDish?.price || null)}
                            time={selectedDish?.time}
                        />
                        {selectedDish && orderingEnabled && (
                            <div className={style.quantitySlot}>
                                <QuantityControl dish={selectedDish} variant="detail" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/*<Modal open={openModal} setOpenModal={setOpenModal} header={"Unlock Favorites"}*/}
            {/*       title={"Unlock the joy of saving your favorites. Download the app now!"}/>*/}
        </View>
    );
};

const styles = StyleSheet.create({
    videoWrapper: {
        width: "100%",
        height: vw(660),
        borderRadius: vw(32),
        overflow: "hidden",
        position: "relative"
    },
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        position: "absolute",
        alignItems: "flex-end",
        bottom: 0,
        left: 0,
        width: "100%",
        height: vw(290),
        paddingHorizontal: vw(16),
        paddingBottom: vw(24),
        color: $white
    },
    videoInfo: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minWidth: 0,
    },
    headerVideo: {
        display: "flex",
        flexDirection: "row",
        gap: vw(4),
        alignItems: "center"
    },
    headerVideoLocation: {
        gap: vw(8)
    },
    locationText: {
        color: $white,
        textAlign: "center",
        fontSize: vw(15),
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: vw(20),
        letterSpacing: -0.24
    },
    menuDies: {
        display: "flex",
        padding: vw(4),
        paddingHorizontal: vw(10),
        alignItems: "flex-start",
        marginHorizontal: vw(4),
        borderRadius: 999,
        borderWidth: vw(1),
        borderColor: $semiTransparentWhite
    },
    menuDies_text: {
        color: $white,
        fontSize: vw(13),
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: vw(18),
        letterSpacing: -0.078
    },
    videoHeader: {
        color: $white,
        fontSize: vw(17),
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: vw(22),
        letterSpacing: -0.408,
        marginBottom: vw(8)
    },
    videoDescription: {
        color: $white,
        fontSize: vw(13),
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: vw(18),
        letterSpacing: -0.078,
        maxWidth: vw(285)
    },
    likes_text: {
        fontSize: vw(11),
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: vw(13),
        letterSpacing: vw(0.066),
        color: $white
    }
});
